(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/closed-view/assets/javascripts/closed-view.js') >= 0) return;  svs.modules.push('/components/racing/closed-view/assets/javascripts/closed-view.js');
"use strict";


const Icon = svs.ui.ReactIcon;
const ClosedView = _ref => {
  let {
    isEnabled,
    header,
    text
  } = _ref;
  if (!isEnabled) {
    return null;
  }
  return React.createElement("div", {
    className: "f-center closed-view"
  }, React.createElement(Icon, {
    color: "fc-racing",
    icon: "information",
    size: "900"
  }), React.createElement("div", {
    className: "closed-view-header"
  }, header), React.createElement("p", {
    className: "closed-view-text"
  }, text));
};
svs.racing.closedView.ClosedView = ClosedView;

 })(window);